import { VoltageSpeedDataQuality } from '../../voltage-with-speed.models';
import { formatEngineOnDuration } from '../kpis/kpis.utils';

function validNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}

export function buildDataQuality(quality: VoltageSpeedDataQuality | null) {
  const known = validNumber(quality?.KnownSeconds);
  const unknown = validNumber(quality?.UnknownSeconds);
  const total = known != null && unknown != null ? known + unknown : 0;
  const knownShare = known != null && unknown != null && total > 0 && Number.isFinite(total) ? known / total * 100 : null;
  const coverage = validNumber(quality?.CoveragePercent);

  return {
    knownShare,
    unknownShare: knownShare == null ? null : 100 - knownShare,
    coverage: coverage != null && coverage <= 100 ? coverage : null,
    knownDuration: known == null ? '—' : `${formatEngineOnDuration(known)} ${Math.floor(known % 60)}s`,
    unknownDuration: unknown == null ? '—' : `${formatEngineOnDuration(unknown)} ${Math.floor(unknown % 60)}s`,
    rows: [
      { label: 'تعداد رکوردها', value: validNumber(quality?.RecordCount) },
      { label: 'وقفه‌های طولانی ثبت داده', value: validNumber(quality?.LongGapCount) },
      { label: 'رکوردهای حرکت با موتور خاموش', value: validNumber(quality?.OffWhileMovingRecords) },
      { label: 'رکوردهای ولتاژ نامعتبر', value: validNumber(quality?.InvalidVoltageRecords) },
      { label: 'رکوردهای سرعت نامعتبر', value: validNumber(quality?.InvalidSpeedRecords) }
    ]
  };
}
